import React from 'react';

import './styles.scss';

// components
import Card from '../cards/card/Card';
import Demo from '../forms/Demo';
import Wysiwyg from '../tools/wysiwyg/Wysiwyg';
import TableSpecs from '../tools/wysiwyg/parts/tableSpecs/TableSpecs';

function UiKit() {
  const icons = [
    'activity',
    'arrow-link',
    'arrow-top',
    'artwork',
    'book',
    'check',
    'chevron-large',
    'chevron',
    'close-large',
    'close',
    'enlarge',
    'heart-full',
    'heart',
    'home',
    'menu',
    'offsite',
    'pdf',
    'print',
    'ressource',
    'search',
    'share',
  ];
  const bigIcons = [
    'activity-detail',
    'artwork-detail',
    'ressource-detail',
    'play',
    'heart',
    'heart-full',
  ];
  return (
    <div className="uikit">
      <section className="uikit__section">
        <h1 className="uikit__title">Ui Kit</h1>
      </section>

      <section className="uikit__section uikit__section--fonts">
        <h2 className="uikit__subtitle">Fonts</h2>
        <dl className="fonts-list">
          <dt>Graphik - Sans serif</dt>
          <dd>Freight - Serif</dd>
        </dl>
      </section>

      <section className="uikit__section uikit__section--icons">
        <h2 className="uikit__subtitle">Icons</h2>
        <div className="icons">
          {icons.map((icon) =>
            <span key={icon} className={`icon icon--${icon}`} />,
          )}
        </div>
        <div className="big-icons">
          {bigIcons.map((icon) =>
            <span key={icon} className={`icon icon--big icon--${icon}`} />,
          )}
        </div>
      </section>

      <section className="uikit__section uikit__section--colors">
        <h2 className="uikit__subtitle">Colors</h2>
        <div className="color-swatches">
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#000000' }} />
            <pre className="color-name">$black</pre>
            <pre className="color-value">#000000</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#19191A' }} />
            <pre className="color-name">$black-light</pre>
            <pre className="color-value">#19191A</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#979797' }} />
            <pre className="color-name">$grey-medium</pre>
            <pre className="color-value">#979797</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#f4f4f4' }} />
            <pre className="color-name">$grey-light</pre>
            <pre className="color-value">#f4f4f4</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#ffffff' }} />
            <pre className="color-name">$white</pre>
            <pre className="color-value">#ffffff</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#DBD530' }} />
            <pre className="color-name">$yellow</pre>
            <pre className="color-value">#DBD530</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#F07575' }} />
            <pre className="color-name">$red</pre>
            <pre className="color-value">#F07575</pre>
          </div>
          <div className="color-item color">
            <div className="color-swatch" style={{ backgroundColor: '#76B7E6' }} />
            <pre className="color-name">$blue</pre>
            <pre className="color-value">#76B7E6</pre>
          </div>
        </div>
      </section>

      <section className="uikit__section uikit__section--cards">
        <h2 className="uikit__subtitle">Cards</h2>
        <div className="grid">
          <ul className="grid__items">
            <li className="grid__item">
              <Card
                title="Card title"
                subtitle="Card subtitle"
                image="https://images.unsplash.com/photo-1527694632654-7c9e115b2fde?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
                cardType="activity"
                recommandationCount="10"
                slug="/en/activities"
              />
            </li>
            <li className="grid__item">
              <Card
                title="Card title"
                subtitle="Card subtitle"
                image="https://images.unsplash.com/photo-1548890232-88737d2917c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=676&q=80"
                cardType="artwork"
                slug="/en/artworks"
              />
            </li>
            <li className="grid__item">
              <Card
                title="Card title"
                subtitle="Card subtitle"
                image="https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=80"
                cardType="resource"
                resourceType="video"
              />
            </li>
            <li className="grid__item">
              <Card
                title="Card title"
                subtitle="Card subtitle"
                image="https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=80"
                cardType="resource"
                resourceType="file"
                url="http://google.com"
              />
            </li>
            <li className="grid__item">
              <Card
                title="Card title"
                subtitle="Card subtitle"
                image="https://images.unsplash.com/photo-1527694632654-7c9e115b2fde?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
                cardType="activity"
                recommandationCount="0"
                slug="/en/activities"
              />
            </li>
          </ul>
        </div>
      </section>

      <section className="uikit__section uikit__section--buttons">
        <h2 className="uikit__subtitle">Buttons</h2>
        <div className="buttons">
          <span className="buttons__title">
            Buttons
          </span>
          <span className="buttons__name">
            Button
          </span>
          <button className="button">
            Button
          </button>
          <br />
          <span className="buttons__name">
            Button --border
          </span>
          <button className="button button--border">
            Button Border
          </button>
          <br />
          <span className="buttons__name">
            Button --fill
          </span>
          <button className="button button--fill">
            Button Fill
          </button>
          <br />
          <span className="buttons__name">
            Button --icon
          </span>
          <button className="button button--icon">
            Button with icon
          </button>
          <br />
          <span className="buttons__name">
            Button --border --icon
          </span>
          <button className="button button--border button--icon">
            Button Border with icon
          </button>
          <br />
          <span className="buttons__name">
            Button --fill --icon
          </span>
          <button className="button button--fill button--icon">
            Button Fill with icon
          </button>
          <br />
        </div>
        <div className="buttons buttons--light">
          <span className="buttons__title">
            Buttons - Light
          </span>
          <span className="buttons__name">
            Button --light
          </span>
          <button className="button button--light">
            Button
          </button>
          <br />
          <span className="buttons__name">
            Button --border-light
          </span>
          <button className="button button--border-light">
            Button Border
          </button>
          <br />
          <span className="buttons__name">
            Button --fill-light --icon
          </span>
          <button className="button button--fill-light">
            Button Fill
          </button>
          <br />
          <span className="buttons__name">
            Button --light --icon
          </span>
          <button className="button button--light button--icon">
            Button with icon
          </button>
          <br />
          <span className="buttons__name">
            Button --border-light --icon
          </span>
          <button className="button button--border-light button--icon">
            Button Border with icon
          </button>
          <br />
          <span className="buttons__name">
            Button --fill-light --icon
          </span>
          <button className="button button--fill-light button--icon">
            Button Fill with icon
          </button>
          <br />
        </div>
        <div className="buttons">
          <span className="buttons__title">
            Links
          </span>
          <span className="buttons__name">
            Link
          </span>
          <button className="link">
            Link
          </button>
          <br />
          <span className="buttons__name">
            Link --arrow
          </span>
          <button className="link link--arrow">
            Link arrow
          </button>
          <br />
          <span className="buttons__name">
            Link --tool
          </span>
          <button className="link link--tool">
            Link tool
          </button>
          <br />
        </div>
      </section>

      <section className="uikit__section uikit__section--wysiwyg">
        <h2 className="uikit__subtitle">Base HTML / WYSIWYG</h2>
        <Wysiwyg>
          <section>
            <h3 className="uikit__heading">Headings</h3>
            <h1>
              Heading 1 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h1>
            <h2>
              Heading 2 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h2>
            <h3>
              Heading 3 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h3>
            <h4>
              Heading 4 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h4>
            <h5>
              Heading 5 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h5>
            <h6>
              Heading 6 with a <a href="#">link</a>
              <small>Heading subtitle</small>
            </h6>
          </section>

          <section>
            <h3 className="uikit__heading">Address</h3>
            <address>
              Company Name, Inc.<br />
              811 7th Ave, Suite 700<br />
              Manhattan, NY 10019<br />
              USA
            </address>

            <h3 className="uikit__heading">Blockquote</h3>
            <blockquote>
              Maecenas ullamcorper, dui et placerat feugiat, eros pede varius nisi,
              condimentum viverra felis nunc et lorem. Praesent nonummy mi in odio.
              Praesent turpis. Nulla porta dolor. Aliquam lorem ante, dapibus in,
              viverra quis, feugiat a, tellus.
            </blockquote>

            <h3 className="uikit__heading">Details</h3>
            <details open>
              <summary>More info</summary>
              <div>
                <p>Additional information</p>
                <ul>
                  <li>Point 1</li>
                  <li>Point 2</li>
                </ul>
              </div>
            </details>
            <details>
              <summary>More info</summary>
              <div>
                <p>Additional information</p>
                <ul>
                  <li>Point 1</li>
                  <li>Point 2</li>
                </ul>
              </div>
            </details>
            <details>
              <summary>More info</summary>
              <div>
                <p>Additional information</p>
                <ul>
                  <li>Point 1</li>
                  <li>Point 2</li>
                </ul>
              </div>
            </details>

            <h3 className="uikit__heading">Figure</h3>
            <figure>
              <img src="http://placehold.it/240x240" alt="alt text 1" />
              <figcaption>Figcaption content</figcaption>
            </figure>

            <figure>
              <img src="http://placehold.it/240x240" alt="alt text 2" />
              <figcaption>
                <h4>Figure Title</h4>
                Figcaption content
              </figcaption>
            </figure>

            <h3 className="uikit__heading">HR</h3>
            <hr />

            <h3 className="uikit__heading">Definition List</h3>
            <TableSpecs
              specs={[
                { name: 'Description name', value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit' },
                { name: 'Name', value: 'Lorem ipsum dolor sit amet' },
                { name: 'Description name', value: 'Lorem ipsum' },
                { name: 'Name', value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit' },
              ]}
            />

            <h3 className="uikit__heading">Ordered List</h3>
            <ol>
              <li>list item 1</li>
              <li>list item 1
                <ol>
                  <li>list item 2</li>
                  <li>list item 2
                    <ol>
                      <li>list item 3</li>
                      <li>list item 3</li>
                    </ol>
                  </li>
                  <li>list item 2</li>
                  <li>list item 2</li>
                </ol>
              </li>
              <li>list item 1</li>
              <li>list item 1</li>
            </ol>

            <h3 className="uikit__heading">Unordered List</h3>
            <ul>
              <li>list item 1</li>
              <li>
                Sed nisi lacus, tincidunt id viverra gravida, dictum lobortis magna.
                Curabitur venenatis placerat urna vitae aliquet. Curabitur quis finibus quam.
                Vestibulum ut tellus sed dolor imperdiet pharetra.
                <ul>
                  <li>list item 2</li>
                  <li>list item 2
                    <ul>
                      <li>list item 3</li>
                      <li>list item 3</li>
                    </ul>
                  </li>
                  <li>list item 2</li>
                  <li>list item 2</li>
                </ul>
              </li>
              <li>list item 1</li>
              <li>list item 1</li>
            </ul>

            <h3 className="uikit__heading">Sample text</h3>

            <p>
              Lorem ipsum dolor sit amet, <a href="#">consectetur</a> ad
              dipisicing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut
              et <i>aliquip ex ea commodo consequat</i>. Duis aute irure dolor
              in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat
              non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod tempor incididunt ut labore et dolore
              magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. <b>Duis aute irure dolor</b> in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla
              pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est
              laborum.
            </p>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod tempor incididunt ut labore et dolore
              magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla
              pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est
              laborum.
            </p>

            <ul>
              <li>In voluptate velit esse cillum</li>
              <li>In voluptate velit esse cillum</li>
              <li>In voluptate velit esse cillum</li>
            </ul>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod tempor incididunt ut labore et dolore
              magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla
              pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est
              laborum.
            </p>

            <h3 className="uikit__heading">Default Table</h3>
            <div className="table-wrapper">
              <table className="table" width="600">
                <caption>Table Caption</caption>
                <thead>
                  <tr>
                    <th scope="col">thead th</th>
                    <th scope="col">thead th</th>
                    <th scope="col">thead th</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                  </tr>
                  <tr>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                  </tr>
                  <tr>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                    <td data-th="thead th">tbody td</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>tfoot td</td>
                    <td>tfoot td</td>
                    <td>tfoot td</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <h3 className="uikit__heading">Other</h3>
            <p>The <a href="#">a element</a> example</p>
            <p>The <abbr>abbr element</abbr> and an <abbr title="Abbreviation">abbr</abbr> element with title examples</p>
            <p>The <b>b element</b> example</p>
            <p>The <em>em element</em> example</p>
            <p>The <i>i element</i> example</p>
            <p>The <mark>mark element</mark> example</p>
            <p>The <q>q element</q> example</p>
            <p>The <q>q element <q>inside</q> a q element</q> example</p>
            <p>The <s>s element</s> example</p>
            <p>The <small>small element</small> example</p>
            <p>The <span>span element</span> example</p>
            <p>The <strong>strong element</strong> example</p>
            <p>The <sub>sub element</sub> example</p>
            <p>The <sup>sup element</sup> example</p>
            <p>The <u>u element</u> example</p>
          </section>
        </Wysiwyg>
      </section>

      <section className="uikit__section uikit__section--forms">
        <h2 className="uikit__subtitle">Forms</h2>
        <Demo />
      </section>

    </div>
  );
}

export default UiKit;



// WEBPACK FOOTER //
// ./src/app/components/uiKit/UiKit.js